import { schema } from "normalizr";

export const customFieldsSchema = new schema.Entity("customFields", {});

export const customFieldsListSchema = [customFieldsSchema];
